export enum MyBetsTrackingConstants {
    MyBets = 'my bets',
    CategoryEvent = 'betting',
    Close = 'close',
}

export interface MyBetsTrackingData {
    action?: string;
    eventDetails?: string;
    positionEvent?: string;
    CategoryEvent?: string;
    LabelEvent?: string;
    PositionEvent?: string;
    LocationEvent?: string;
    URLClicked?: string;
}
